import androidx.compose.ui.graphics.Color
import androidx.compose.runtime.setValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.SideEffect
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.WindowInsetsSides
import androidx.compose.foundation.layout.only
import androidx.compose.foundation.layout.consumeWindowInsets
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Scaffold
import androidx.compose.material3.ScaffoldDefaults
import androidx.compose.material3.Snackbar
import androidx.compose.material3.SnackbarDuration
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.navigation.compose.rememberNavController
import kotlinx.coroutines.launch
import org.jetbrains.compose.ui.tooling.preview.Preview
import org.koin.compose.KoinContext


@Composable
@Preview
fun App() {
    KoinContext {
        // Load the saved Material You preference into the live theme state once at startup.
        val playerPreferences = org.koin.compose.koinInject<PlayerPreferences>()

        // One shared boot sequence for every front end (see AppStartup); the effect's scope lives
        // as long as the app, which the entitlement listener inside it relies on.
        LaunchedEffect(playerPreferences) {
            AppStartup.start(playerPreferences, this)
        }
        remember { theme.ThemePrefs.dynamicColorEnabled.value = playerPreferences.getDynamicColorEnabled() }
        remember(playerPreferences) { DiceDisplayPreferences.restore(playerPreferences) }
        remember(playerPreferences) { SeasonalEffectsPreferences.restore(playerPreferences) }
        // Give brand-new players an uninterrupted first session. Monetization returns on the next
        // launch after they have experienced a game, instead of advertising before the value.
        val showMonetizationThisLaunch = remember(playerPreferences) {
            playerPreferences.getHasCompletedFirstGame()
        }

        // Remote compat gate: builds below the appConfig/appCompat minimum see only the update
        // screen. Checked once per launch; fails open, so an unreachable config never blocks play.
        val updateRequirement by AppUpdateGate.updateRequirement.collectAsState()
        updateRequirement?.let { requirement ->
            UpdateRequiredScreen(requirement)
            return@KoinContext
        }

        val snackbarHostState = remember { SnackbarHostState() }
        // What the shell reserves around screen content (status bar on top, the ad banner below),
        // so the round scrim can be carried over those strips too.
        var shellPadding by remember { mutableStateOf(PaddingValues()) }
        Box(modifier = Modifier.fillMaxSize()) {
        Scaffold(modifier = Modifier.fillMaxSize(),
            // Don't reserve the navigation bar here: the game's dice sheet bleeds behind it and pads
            // its own buttons, and the start screen's Scaffold handles it. The banner pads itself.
            contentWindowInsets = ScaffoldDefaults.contentWindowInsets
                .only(WindowInsetsSides.Top + WindowInsetsSides.Horizontal),
            // Banner + a contextual "Remove ads" tap; hides itself once ads are gone (own purchase
            // or a Plus host's lobby).
            bottomBar = {
                if (showMonetizationThisLaunch) RemoveAdsBanner()
            }
        ) { innerPadding ->
            SideEffect { shellPadding = innerPadding }
            val coroutineScope = rememberCoroutineScope()

            val navController = rememberNavController()
            Box(
                modifier = Modifier
                    .padding(innerPadding)
                    .consumeWindowInsets(innerPadding)
                    .fillMaxSize()
            ) {



                BankoNavHost(
                    navController = navController,
                    onShowSnackbar =
                    { message ->
                        coroutineScope.launch {
                            snackbarHostState.showSnackbar(
                                message,
                                withDismissAction = false,
                                duration = SnackbarDuration.Short
                            )
                        }
                    }
                )
                SnackbarHost(
                    modifier = Modifier.align(Alignment.BottomCenter).imePadding(),
                    hostState = snackbarHostState
                ) {
                    Snackbar(
                        snackbarData = it
                    )
                }
            }

        }
        val edgeScrim = EdgeScrim.alpha.floatValue
        if (edgeScrim > 0f) {
            val scrimColor = Color.Black.copy(alpha = edgeScrim)
            Box(
                Modifier.align(Alignment.TopCenter).fillMaxWidth()
                    .height(shellPadding.calculateTopPadding()).background(scrimColor),
            )
            Box(
                Modifier.align(Alignment.BottomCenter).fillMaxWidth()
                    .height(shellPadding.calculateBottomPadding()).background(scrimColor),
            )
        }
        }
    }
}
